<template>
	<div class="error-message">
		<h1>De pagina kan niet gevonden worden.</h1>
		<p>De opgevraagde pagina kan helaas niet gevonden worden. De pagina bestaat mogelijk niet, is verplaatst of verwijderd.</p>
		<p>Klik <nuxt-link to="/" title="Home">hier</nuxt-link> om terug te keren naar de homepagina.</p>
	</div>
</template>

<script>
	export default {
		name: 'Error404',
		props: [
			'error'
		]
	}
</script>

<style lang="scss"></style>